
export const accountSelector = (state) => state.account;
export const registeredStudentSelector = (state) => state.account.registeredStudent;
export const registerStudentLoadingSelector = (state) => state.account.isLoading;
export const accountBillingInfoSelector = (state) => state.account.accountBillingInfo;
export const complementaryPriceSelector = (state) => state.account.complementaryPrice;
export const authUserSelector = (state) => state.auth.user;
export const invoicesSelector = (state) => state.account.invoices;
